import React, { useMemo } from 'react';

export const makePropsProvider = <T extends Record<string, any>>(...keys: (keyof T)[]) => {
  const PropsContext = React.createContext<T>(null);

  const deps = (props: any) => keys.map((key) => props[key]);
  const factory = (props: any) => () =>
    keys.reduce((values, key) => {
      values[key] = props[key];
      return values;
    }, {} as any);

  const PropsProvider: React.FC<React.PropsWithChildren<T>> = (props) => {
    const { children, ...rest } = props;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const value = useMemo(factory(rest), deps(rest));
    return <PropsContext.Provider value={value}>{children}</PropsContext.Provider>;
  };

  return {
    PropsProvider,
    PropsContext,
  };
};
